import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Check if this is a Google Translate related error
        const isTranslateError = error?.message?.includes('insertBefore') ||
            error?.message?.includes('removeChild') ||
            error?.message?.includes('Node');

        return {
            hasError: true,
            isTranslateError
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error Boundary caught an error", error, errorInfo);

        // Check if this is a Google Translate DOM manipulation error
        if (error?.message?.includes('insertBefore') ||
            error?.message?.includes('removeChild') ||
            error?.message?.includes('Node')) {

            console.warn('Google Translate DOM interference detected. Attempting recovery...');

            // Try to recover by forcing a re-render after a short delay
            setTimeout(() => {
                this.setState({ hasError: false, isTranslateError: false });
            }, 100);
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.state.isTranslateError) {
                // For translate errors, show a brief loading state then recover
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100px'
                    }}>
                        <div>Loading...</div>
                    </div>
                );
            }

            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
